import { render, staticRenderFns } from "./priceList.vue?vue&type=template&id=34e817c2&scoped=true"
import script from "./priceList.vue?vue&type=script&lang=js"
export * from "./priceList.vue?vue&type=script&lang=js"
import style0 from "./priceList.vue?vue&type=style&index=0&id=34e817c2&prod&lang=scss&scoped=true"
import style1 from "./priceList.vue?vue&type=style&index=1&id=34e817c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e817c2",
  null
  
)

export default component.exports